import { Directive } from '@angular/core';

@Directive({
  selector: '[appOverlayTop]'
})
export class OverlayTopDirective { }
